<mat-dialog-content class="h-full">
  <div class="flex flex-col place-items-center items-stretch tk-bg-gray-5 rounded-lg">

    <div class="flex justify-between tk-bg-gray-5 px-5 mt-5 mb-3">
      <span class="font-semibold text-base">{{'data-sharing.link-added' | translate}}</span>
    </div>

    <div class="px-5 mb-4 bg-white tk-bg-gray-5 text-sm">
      <div class="flex items-center bg-white rounded-xl py-2">
        <sm-copy-to-clipboard [isAutoCopy]="true" [data]="this.model.url" class="mx-2"></sm-copy-to-clipboard>
        <span id="url" class="mr-3">{{model.url}}</span>
      </div>
    </div>

    <div class="flex items-center justify-between px-5 py-4 bg-white bg-white rounded-b-lg">
      <span class="flex">
        <span class="tk-c-gray-9 mr-1">{{'data-sharing.valid' | translate}}:</span>
        <span *ngIf="model.link.endDate; else alwaysTemp" class="font-semibold">
          {{model.link.startDate | date:'short'}} - {{model.link.endDate | date:'short'}}
        </span>
        <ng-template #alwaysTemp>
          <span class="font-semibold">{{'labels.always' | translate | titlecase}}</span>
        </ng-template>
      </span>

      <span class="flex items-center">
        <span class="tk-c-gray-9 mr-1">{{'labels.vehicles' | translate | titlecase}}:</span>
        <span
          class="flex justify-center items-center w-auto h-6 rounded-full text-center text-xs tk-bg-blue text-white">
          <span class="mx-2">{{model.fullVehicles.length}}</span>
        </span>
      </span>

      <span class="flex items-center">
        <sm-copy-to-clipboard [data]="allDataAsText()" class="mr-2"></sm-copy-to-clipboard>
        <span class="">{{'labels.copy-all-data' | translate}}</span>
      </span>

    </div>
  </div>

  <div class="mt-4">
    <button mat-flat-button color="primary" type="button" (click)="onClose()"
            class="flex justify-center items-center font-normal hover:font-normal">
      <div class="mx-6 text-sm text-white">{{'labels.close' | translate | titlecase}}</div>
    </button>
  </div>
</mat-dialog-content>
